/* Component in the ScheduleScene to display the extra info */
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import styles from "../../../styles/ScheduleCreate.module.css";

const SchedSceneInfo = (props) => {
     const { title, dramatic_day, location_address, action,
            time, location_detail, day_night,
            equip_set_props, new_info, pages,
            department_info } = props;

    return (
        <div className={`text-center py-2 mb-2 mx-2 px-2 ${styles.SceneBox}`}>
        <Row className='text-center mt-2'>
        <Col className={`${styles.BorderRight} mx-0 px-1 mb-0 pb-1`} xs={6} >
        <div className='d-none d-md-block'>
        <p className={`mb-2 mx-2 mx-md-5 ${styles.BoldTitle}`} >
            DAY/NIGHT</p>
        <div className={`${styles.Hig20}`}>
            <p className='pb-0 pb-sm-0'>{day_night} </p>
        </div>
        </div>
        <div className='d-block d-md-none'>
        <p className={`mb-2 mx-2 mx-md-5 ${styles.BoldTitle}`} >
            D/N - PAGES</p>
        <div className={`${styles.Hig20}`}>
            <p className='pb-0 pb-sm-0'>{day_night} - {pages}</p>
        </div>
        </div>
        </Col>
        <Col xs={6} className={`mx-0 px-1 mb-0 pb-1`} >
        <p className={`mb-2 mx-2 mx-md-5 ${styles.BoldTitle}`}>
        DRAMATIC DAY</p>
        <div className={`${styles.Hig20}`}>
        <p className='pb-0'>{dramatic_day} </p>
        </div>
        </Col>
        </Row>
        {/* hr */}
        <Row>
        <Col xs={12}>
        <hr className={`mt-0 mb-0`}/>
        </Col>
        </Row>
        <Row className='text-center'>
            <Col className={`${styles.BorderRight} mt-2 mx-0 px-1 mb-0 pb-1`} xs={12} sm={6} >
            <p className={`mb-2 mx-5 ${styles.BoldTitle}`} >
                HEADING INFO</p>
            <div className={`${styles.Hig20}`}>
                <p className='pb-0 pb-sm-0'>{title} </p>
            </div>
            <hr className={`d-block d-sm-none mt-0 mb-0`}/>
            </Col>
            <Col xs={12} sm={6} className={`mt-2 mx-0 px-3 mb-0 pb-1`} >
            <p className={`mb-2 mx-5 ${styles.BoldTitle}`}>
            ACTION</p>
            <div className={`${styles.Hig20}`}>
            <p className='pb-0'>{action} </p>
            </div>
            <hr className={`d-block d-sm-none mt-1 mb-0`}/>
            </Col>
        </Row>
        {/* hr */}
        <Row>
        <Col xs={12}>
        <hr className={`d-none d-sm-block mt-0 mb-0`}/>
        </Col>
        </Row>
        {/* address equip */}
        <Row className='text-center'>
        <Col xs={12} sm={6} className={`mt-2 mx-0 px-1 mb-0 pb-1 ${styles.BorderRight}`} >
            <p className={`mb-2 mx-5 ${styles.BoldTitle}`} >
            FILMING ADDRESS </p>
            <div className={`${styles.Hig20}`}>
            <p className=''>{location_address} </p>
            </div>
            <hr className={`d-block d-sm-none mt-0 mb-0`}/>
        </Col>
        <Col xs={12} sm={6} className={`mt-2 mx-0 px-1 mb-0 pb-1 ${styles.BorderRight}`} >
            <p className={`mb-2 mx-5 ${styles.BoldTitle}`} >
            PARKING/DIRECTIONS/NOTES</p>
            <div className={`${styles.Hig20}`}>
            <p className=''>{time} </p>
            </div>
            <hr className={`d-block d-sm-none mt-0 mb-0`}/>
        </Col>
        </Row>
        {/* hr */}
        <Row>
        <Col xs={12}>
        <hr className={`d-none d-md-block mt-0 mb-0`}/>
        </Col>
        </Row>
        {/* set - SFX/VFX */}
        <Row className='text-center'>        
            <Col className={`mt-2 mx-0 px-1 mb-0 pb-1`} xs={12} sm={6}>
            <p className={`mb-2 mx-5 ${styles.BoldTitle}`} >
                EQUIP/SET/PROPS</p>
            <div className={`${styles.Hig20}`}>
            <p >{equip_set_props} </p>
            </div>
            <hr className={`d-block d-sm-none mt-0 mb-0`}/>
            </Col>
            <Col className={`mt-2 mx-0 px-1 mb-0 pb-1`} xs={12} sm={6}>
            <p className={`mb-2 mx-5 ${styles.BoldTitle}`} >
                SFX/VFX</p>
            <div className={`${styles.Hig20}`}>
            <p >{location_detail} </p>
            </div>
            <hr className={`d-block d-sm-none mt-0 mb-0`}/>
            </Col>
        </Row>
        {/* hr */}
        <Row>
        <Col xs={12}>
        <hr className={`d-none d-md-block mt-0 mb-0`}/>
        </Col>
        </Row>
        {/* depts */}
        <Row className='text-center'>
            <Col className={`mt-2 mx-0 px-1 mb-0 pb-1`} xs={12}>
            <p className={`mb-2 mx-5 ${styles.BoldTitle}`}>
                DEPARTMENTS/SHOOT INFO </p>
            <div className={`${styles.Hig20}`}>
            <p >{department_info} </p>
            <p className='mt-2'>{new_info}</p>
            </div>
            </Col>
        </Row>
        </div>
    )
}

export default SchedSceneInfo
